import {ChannelTranslation} from '@core/shared/models/channel-translation';
import {Society} from '@core/shared/models/society';
import {Currency} from "@core/shared/models/currency";
import {OfferCatalog} from "@core/shared/models/offer/offer-catalog";
import {ChannelStyle} from "@core/shared/models/channel-style";
import {OfferPermanentOption} from "@core/shared/models/offer/offer-permanent-option";
import {SocietyWebsite} from "@core/shared/models/society/society-website";
import {ChannelSort} from "@core/shared/models/channel-sort";
import {SocietyIp} from "@core/shared/models/society/society-ip";
import {File} from '@lib/media/file/file';
import {User} from '@core/shared/models/user';

export enum ChannelMode {
    Classic = 'classic',
    Restricted = 'restricted'
}

export type ChannelIntegrationMode = 'subDomain' | 'JS' | 'API' | 'orchestra';

export interface Channel {

    id: number;

    createdAt: string;

    updatedAt: string;

    marketplace: SocietyWebsite;

    individualQuota: number;

    groupQuota: number;

    isDistributor: boolean;

    translations: ChannelTranslation[];

    society: Society;

    owner: User;

    lastUpdatedUser: User;

    locale: string;

    offerCatalogs: OfferCatalog[];

    currency: Currency;

    comment: string;

    style: ChannelStyle;

    sort: ChannelSort;

    tokenJs: string;

    enableJS: boolean;

    enableSubDomain: boolean;

    enableApi: boolean;

    enableOrchestra: boolean;

    subDomain: string;

    permanentOptions: OfferPermanentOption[];

    referenced: boolean;

    canonicalUrl: string;

    allowGiftVoucher: boolean;

    allowBooking: boolean;

    allowRequest: boolean;

    allowOnlineSale: boolean;

    allowShowcase: boolean;

    enable: boolean;

    picture: {
        copyright: string;
        image: {}
    };

    pictureUrl: string;

    logo: {
        copyright: string;
        image: {}
    };

    logoUrl: string;

    favicon: File;

    allowedIps: SocietyIp[];

    displayStartFromPrice: boolean;

    isRestricted: boolean;

    isUpdateAllowed: boolean;

    isDeleteAllowed: boolean;
}
